import { Modal } from './Modal'
import { GrowthCentileChart } from './GrowthCentileChart'
import { Patient } from '../types/patient'
import './GrowthCentileChartsDialog.css'

interface GrowthCentileChartsDialogProps {
  patientId: string
  patient: Patient
  isOpen: boolean
  onClose: () => void
}

export function GrowthCentileChartsDialog({
  patientId,
  patient,
  isOpen,
  onClose,
}: GrowthCentileChartsDialogProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Growth Charts (UK-WHO / WHO 2006)"
      size="large"
    >
      <div className="growth-centile-charts-dialog-body">
        <div className="growth-centile-charts-grid">
          <GrowthCentileChart
            patientId={patientId}
            patient={patient}
            chartType="weight"
            height={300}
          />
          <GrowthCentileChart
            patientId={patientId}
            patient={patient}
            chartType="height"
            height={300}
          />
          <GrowthCentileChart
            patientId={patientId}
            patient={patient}
            chartType="bmi"
            height={300}
          />
          <GrowthCentileChart
            patientId={patientId}
            patient={patient}
            chartType="headCircumference"
            height={300}
          />
        </div>
      </div>
    </Modal>
  )
}
